import {
  Component,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  ToastrService,
  ExportService,
  LoggingService,
  UsersCreatedDataTotal,
  UserCreatedData,
} from "app/shared";
import { BaseChartLogic } from "app/analytics/BaseChartLogic";
import { UsersCreatedTotalConfig } from "app/shared/model/charts/user-analytic-configurations.model";

@Component({
  selector: "users-created-chart-total",
  templateUrl: "../../common-chart-template.component.html",
  standalone: false,
})
export class UsersCreatedTotalChartComponent
  extends BaseChartLogic<UsersCreatedTotalConfig, UsersCreatedDataTotal>
  implements OnInit, OnDestroy
{
  @Input() startDate: Date | null = null;
  @Input() endDate: Date | null = null;
  @Input() showTitle: boolean = true;
  @ViewChild("chartCanvas") chartCanvas!: ElementRef<HTMLCanvasElement>;

  constructor(
    _analyticsService: AnalyticsService,
    _authService: AuthorizationService,
    _exportService: ExportService,
    _toastrService: ToastrService,
    _loggingService: LoggingService,
    _ngZone: NgZone
  ) {
    super(
      _analyticsService,
      _authService,
      _exportService,
      _toastrService,
      _loggingService,
      UsersCreatedTotalConfig,
      _ngZone
    );
    this.handleDataSubscription(
      this.analyticsService.usersCreatedDataTotalChange
    );
  }

  dataPointKey: string = "Total";
  getDataPointDisplayValue(dataPoint: UserCreatedData): any {
    return dataPoint.Total;
  }

  buildFilterSettings(): void {
    this.addPeriodtoFilterSettings();
    this.addStartEndDatesToFilterSettings(this.startDate, this.endDate);
  }

  refreshData(): void {
    this.analyticsService.getCreatedUsersDataTotal(this.filterSettings);
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }
}
